import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MyProfileService } from '@src/app/modules/my-profile/my-profile.service';
import { CommonService } from '@src/app/services/common.service';
import { formatTinyNumber } from '@src/app/shared/utils/number.util';
import { environment } from '@src/environments/environment';
import { toPng } from 'html-to-image';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { MemeDashboardService } from '../../meme-dashboard.service';
import { WatchlistAgentInfo } from '../../meme-dashboard.type';

@Component({
    selector: 'app-share-to-socialmedia-modal',
    templateUrl: './share-to-socialmedia-modal.component.html',
    styleUrls: ['./share-to-socialmedia-modal.component.less'],
})
export class ShareToSocialmediaModalComponent implements OnInit, OnDestroy {
    readonly modalData: { agentInfo: WatchlistAgentInfo } = inject(NZ_MODAL_DATA);
    @ViewChild('contentToDownload') contentToDownload!: ElementRef;

    formatTinyNumber = formatTinyNumber;

    get agentInfo() {
        return this.modalData.agentInfo;
    }

    get referralCode() {
        return this.myProfileService.referralCode;
    }

    shareLink: string;

    scale = 1;

    generatingImage = false;

    constructor(
        private myProfileService: MyProfileService,
        private memeDashboardService: MemeDashboardService,
        public commonService: CommonService,
        private http: HttpClient,
        private message: NzMessageService
    ) {}

    ngOnInit() {
        const queryParams = new URLSearchParams();
        queryParams.set('invitation_code', this.myProfileService.referralCode);
        queryParams.set('path_after_login', `/meme-dashboard/watchlist-marketplace/${this.agentInfo.id}`);
        queryParams.set('show_login', '1');

        const longShareLink = `https://${environment.production ? '' : 'dev.'}socialscan.io/meme-dashboard?${queryParams}`;
        this.shareLink = longShareLink;

        // 计算缩放比例
        this.calculateScale();

        // 监听窗口大小变化
        window.addEventListener('resize', () => this.calculateScale());
    }

    ngOnDestroy() {
        // 记得移除监听器
        window.removeEventListener('resize', () => this.calculateScale());
    }

    private calculateScale() {
        const containerWidth = 538; // 原始宽度
        const screenWidth = window.innerWidth;
        const padding = 64; // 左右各留16px的padding

        if (screenWidth < containerWidth + padding) {
            this.scale = (screenWidth - padding) / containerWidth;
        } else {
            this.scale = 1;
        }
    }

    startShareToTwitter() {
        this.memeDashboardService.shareToTwitter(this.agentInfo, 'other');
    }

    async copyToClipboard() {
        try {
            this.generatingImage = true;
            const element = this.contentToDownload.nativeElement;

            const dataUrl = await toPng(element, {
                quality: 1.0,
                pixelRatio: 2,
                cacheBust: true,
            });

            const response = await fetch(dataUrl);
            const blob = await response.blob();

            try {
                await navigator.clipboard.write([
                    new ClipboardItem({
                        'image/png': blob,
                    }),
                ]);
                this.message.success('Image copied to clipboard');
            } catch (err) {
                console.error('Failed to copy to clipboard:', err);
                // 如果复制失败，回退到下载
                const link = document.createElement('a');
                link.download = 'share.png';
                link.href = dataUrl;
                link.click();
            }
        } catch (error) {
            console.error('Error generating image:', error);
        } finally {
            this.generatingImage = false;
        }
    }
}
